import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0f172a] border-t border-slate-800/50" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-12">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mb-8 text-center" data-id="element-13">
            Sobre George Capital Coaching
          </h2>

          <div className="space-y-6 text-slate-300 text-lg leading-relaxed" data-id="element-14">
            <p data-id="element-15">
              George Capital Coaching es una firma de consultoría y educación
              financiera diseñada para las personas modernas que buscan
              resultados, no teorías.
            </p>
            <p data-id="element-16">
              Creemos que la libertad financiera no se logra con fórmulas
              mágicas, sino con{' '}
              <strong className="text-white font-semibold" data-id="element-17">
                orden, sistemas y control absoluto del flujo de caja
              </strong>
              . Nuestra metodología se aleja de los tecnicismos bancarios para
              ofrecer pasos prácticos y accionables que cualquier persona puede
              implementar desde el primer día.
            </p>
            <p data-id="element-18">
              Nuestro compromiso es ayudarte a silenciar la ansiedad financiera
              y transformar tu relación con el dinero, permitiéndote construir
              un patrimonio sólido basado en{' '}
              <strong className="text-white font-semibold" data-id="element-19">
                decisiones inteligentes y hábitos sustentables
              </strong>
              .
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}